import { render, staticRenderFns } from "./SleepTimer.vue?vue&type=template&id=0c2252b6&scoped=true"
import script from "./SleepTimer.vue?vue&type=script&lang=js"
export * from "./SleepTimer.vue?vue&type=script&lang=js"
import style0 from "./SleepTimer.vue?vue&type=style&index=0&id=0c2252b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2252b6",
  null
  
)

export default component.exports